// Opacity-only, deliberately no transform (y/scale/etc). Layout.jsx's outer
// wrapper is persistently transform: scale(...)'d for the responsive
// fit-to-viewport feature — animating a transform on a descendant of an
// already-scaled ancestor makes browsers composite from a lower-resolution
// texture mid-animation, which reads as a blur-then-sharpen flicker even
// though no CSS blur() filter is ever applied.
export const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const pageTransition = {
  duration: 0.4,
  ease: "circOut",
};